import type { EstateAnalysis } from './analytics';

const CATEGORIES = ['shopping', 'catering', 'leisure', 'health'];

type LocationScores = {
  scores: Record<string, number>;
  internalScores: Record<string, number>;
};

export const useLocationScores = (estateAnalysis: EstateAnalysis) => {
  const data: LocationScores = {
    scores: {},
    internalScores: {},
  };
  if (estateAnalysis.locationScores?.data?.scores) {
    Object.entries(estateAnalysis.locationScores.data.scores).forEach(([key, { score }]) => {
      if (CATEGORIES.includes(key)) {
        data.scores[key] = score;
        data.internalScores[key] = Math.round(score * 5 * 10) / 10;
      }
    });
  }

  return { data, categories: CATEGORIES };
};
